import styled from '@emotion/styled';

const StyledNoData = styled.div`
  color: var(--dk-text-secondary, #888d96);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
`;

const StyledTargetTime = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;

  :hover {
    background-color: var(--dk-bg-muted, #f3f5f6);
  }
  padding: 8px 12px;
  border-radius: 4px;

  &:hover .outlook-choice {
    opacity: 1;
  }
  .outlook-choice {
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  cursor: pointer;
  :disabled {
    opacity: 0.5;
    :hover {
      background-color: inherit;
    }
    cursor: auto;
  }
`;

const TimeContainer = styled.div`
  margin-top: 8px;
  margin-left: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DataContainer = styled.div<{ today?: boolean; mobileMode?: boolean }>`
  padding: ${({ mobileMode }) => (mobileMode ? '12px 4px' : '12px')};
  border-top: 1px solid var(--dk-line, #e7e9ec);
  color: ${({ today }) => (today ? 'var(--dk-accent, #06C)' : 'var(--dk-text, black)')};
  &:nth-child(1) {
    border-top: none;
    padding-top: ${({ mobileMode }) => (mobileMode ? '0' : '12px')};
  }
`;

const StyledTime = styled.div<{ selected: boolean }>`
  //color: var(--dk-text-secondary, #888d96);
  color: ${({ selected }) => (selected ? 'var(--dk-accent, #06C)' : 'var(--dk-text-secondary, #888d96)')};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 128.571% */
`;

const StyledTitle = styled.div<{ selected: boolean }>`
  color: ${({ selected }) => (selected ? 'var(--dk-accent, #06C)' : 'var(--dk-text, black)')};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 128.571% */
  flex-grow: 1;
  text-align: start;
`;
const StyledButton = styled.button`
  display: flex;
  min-width: 64px;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  border-radius: 4px;
  border: 1px solid var(--dk-line, #e7e9ec);
  background: var(--dk-bg, #fff);
`;

const LoadingContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
`;

export {
  StyledNoData,
  StyledTargetTime,
  TimeContainer,
  DataContainer,
  StyledTime,
  StyledTitle,
  StyledButton,
  LoadingContainer,
};
